import { usePublicLodgingsByListingQuery } from "~graphql/generated/graphql"

export default function useLodgingsByListing(listingId?: string) {
    const {
        data,
        loading: isLoading,
        error,
    } = usePublicLodgingsByListingQuery({
        variables: { listingId: listingId! },
        skip: !listingId,
    })
    const lodgings = data?.publicLodgingsByListing ?? []

    return { lodgings, isLoading, error }
}
